import UserService from '@/services/common/UserService';

const userService = new UserService();

export const getAllUsers = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    const users = await userService.getAllUsers();
    commit('allUsers', users);
    commit('isFetching', false);
}

export const getUser = async({ commit }: {commit: Function}, userId: string) => {
    commit('isFetching', true);
    const user = await userService.getUser(userId);
    commit('user', user);
    commit('isFetching', false);
}

export const getAllUsersByOrg = async({ commit }: {commit: Function}, orgId: string) => {
    commit('isFetching', true);
    const users = await userService.getUsers(orgId);
    commit('usersInOrg', users);
    commit('userOrgSelected', orgId);
    commit('isFetching', false);
}
export const getAllEnergyUsersByOrg = async({ commit }: {commit: Function}, orgId: string) => {
    commit('isFetching', true);
    const users = await userService.getEnergyUsers(orgId);
    commit('usersInOrg', users);
    commit('userOrgSelected', orgId);
    commit('isFetching', false);
}

export const createUser = async({ commit }: {commit: Function}, payload: any) => {
    await userService.createUser(payload.user);
}

export const deactivateUser = async({ commit }: {commit: Function}, userId: string) => {
    await userService.deactivateUser(userId);
}
export const getAllDeactivatedUsers = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    const users = await userService.getAllDeactivatedUsers();
    commit('deactivatedUsers', users);
    commit('isFetching', false);
}
export const activateUser = async({ commit, dispatch }: {commit: Function, dispatch: Function}, userId: string) => {
    await userService.activateUser(userId);
    dispatch('getAllDeactivatedUsers');
}

export const saveUser = async({ commit }: { commit: Function }, payload: any) => {
    await userService.saveUser(payload.userId, payload.user);
}
